/**
 * useIsAdmin — reads the `isAdmin` flag from the server-authoritative
 * /user/profile response. The allowlist (ADMIN_EMAILS) lives only in the
 * Lambdas; the frontend never holds a copy.
 */
import { useUser } from './usePolling.js';

export function useIsAdmin() {
  const { user, loading } = useUser(true);
  return { isAdmin: !!user?.isAdmin, loading };
}
